// extracted by mini-css-extract-plugin
module.exports = {"noDataWrapper":"NoTableDataAvailable_noDataWrapper__3OiUR"};